// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: W9XdlIeiuX

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicArrows.module.css"; // plasmic-import: W9XdlIeiuX/css

import ArrowIosLeftsvgIcon from "./icons/PlasmicIcon__ArrowIosLeftsvg"; // plasmic-import: mqQZiFLGtA/icon
import ArrowIosRightsvgIcon from "./icons/PlasmicIcon__ArrowIosRightsvg"; // plasmic-import: 5TngLItwC/icon

createPlasmicElementProxy;

export type PlasmicArrows__VariantMembers = {
  leftHidden: "leftHidden";
  rightHidden: "rightHidden";
  small: "small";
};
export type PlasmicArrows__VariantsArgs = {
  leftHidden?: SingleBooleanChoiceArg<"leftHidden">;
  rightHidden?: SingleBooleanChoiceArg<"rightHidden">;
  small?: SingleBooleanChoiceArg<"small">;
};
type VariantPropType = keyof PlasmicArrows__VariantsArgs;
export const PlasmicArrows__VariantProps = new Array<VariantPropType>(
  "leftHidden",
  "rightHidden",
  "small"
);

export type PlasmicArrows__ArgsType = {};
type ArgPropType = keyof PlasmicArrows__ArgsType;
export const PlasmicArrows__ArgProps = new Array<ArgPropType>();

export type PlasmicArrows__OverridesType = {
  root?: p.Flex<"div">;
  leftArrow?: p.Flex<"button">;
  left?: p.Flex<"svg">;
  rightArrow?: p.Flex<"button">;
  right?: p.Flex<"svg">;
};

export interface DefaultArrowsProps {
  leftHidden?: SingleBooleanChoiceArg<"leftHidden">;
  rightHidden?: SingleBooleanChoiceArg<"rightHidden">;
  small?: SingleBooleanChoiceArg<"small">;
  className?: string;
}

const $$ = {};

function PlasmicArrows__RenderFunc(props: {
  variants: PlasmicArrows__VariantsArgs;
  args: PlasmicArrows__ArgsType;
  overrides: PlasmicArrows__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "leftHidden",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.leftHidden
      },
      {
        path: "rightHidden",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.rightHidden
      },
      {
        path: "small",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.small
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        { [sty.rootleftHidden]: hasVariant($state, "leftHidden", "leftHidden") }
      )}
    >
      <button
        data-plasmic-name={"leftArrow"}
        data-plasmic-override={overrides.leftArrow}
        className={classNames(
          projectcss.all,
          projectcss.button,
          sty.leftArrow,
          {
            [sty.leftArrowglobal_theme_dark]: hasVariant(
              globalVariants,
              "theme",
              "dark"
            ),
            [sty.leftArrowleftHidden]: hasVariant(
              $state,
              "leftHidden",
              "leftHidden"
            ),
            [sty.leftArrowsmall]: hasVariant($state, "small", "small")
          }
        )}
        ref={ref => {
          $refs["leftArrow"] = ref;
        }}
      >
        {(hasVariant($state, "leftHidden", "leftHidden") ? false : true) ? (
          <ArrowIosLeftsvgIcon
            data-plasmic-name={"left"}
            data-plasmic-override={overrides.left}
            className={classNames(projectcss.all, sty.left, {
              [sty.leftglobal_theme_dark]: hasVariant(
                globalVariants,
                "theme",
                "dark"
              ),
              [sty.leftleftHidden]: hasVariant(
                $state,
                "leftHidden",
                "leftHidden"
              ),
              [sty.leftrightHidden]: hasVariant(
                $state,
                "rightHidden",
                "rightHidden"
              ),
              [sty.leftsmall]: hasVariant($state, "small", "small")
            })}
            role={"img"}
          />
        ) : null}
      </button>
      <button
        data-plasmic-name={"rightArrow"}
        data-plasmic-override={overrides.rightArrow}
        className={classNames(
          projectcss.all,
          projectcss.button,
          sty.rightArrow,
          {
            [sty.rightArrowglobal_theme_dark]: hasVariant(
              globalVariants,
              "theme",
              "dark"
            ),
            [sty.rightArrowleftHidden]: hasVariant(
              $state,
              "leftHidden",
              "leftHidden"
            ),
            [sty.rightArrowsmall]: hasVariant($state, "small", "small")
          }
        )}
        ref={ref => {
          $refs["rightArrow"] = ref;
        }}
      >
        {(hasVariant($state, "rightHidden", "rightHidden") ? false : true) ? (
          <ArrowIosRightsvgIcon
            data-plasmic-name={"right"}
            data-plasmic-override={overrides.right}
            className={classNames(projectcss.all, sty.right, {
              [sty.rightglobal_theme_dark]: hasVariant(
                globalVariants,
                "theme",
                "dark"
              ),
              [sty.rightleftHidden]: hasVariant(
                $state,
                "leftHidden",
                "leftHidden"
              ),
              [sty.rightrightHidden]: hasVariant(
                $state,
                "rightHidden",
                "rightHidden"
              ),
              [sty.rightsmall]: hasVariant($state, "small", "small")
            })}
            role={"img"}
          />
        ) : null}
      </button>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "leftArrow", "left", "rightArrow", "right"],
  leftArrow: ["leftArrow", "left"],
  left: ["left"],
  rightArrow: ["rightArrow", "right"],
  right: ["right"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  leftArrow: "button";
  left: "svg";
  rightArrow: "button";
  right: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicArrows__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicArrows__VariantsArgs;
    args?: PlasmicArrows__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicArrows__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicArrows__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicArrows__ArgProps,
          internalVariantPropNames: PlasmicArrows__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicArrows__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicArrows";
  } else {
    func.displayName = `PlasmicArrows.${nodeName}`;
  }
  return func;
}

export const PlasmicArrows = Object.assign(
  // Top-level PlasmicArrows renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    leftArrow: makeNodeComponent("leftArrow"),
    left: makeNodeComponent("left"),
    rightArrow: makeNodeComponent("rightArrow"),
    right: makeNodeComponent("right"),

    // Metadata about props expected for PlasmicArrows
    internalVariantProps: PlasmicArrows__VariantProps,
    internalArgProps: PlasmicArrows__ArgProps
  }
);

export default PlasmicArrows;
/* prettier-ignore-end */
